import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';

export default function getDateMinMaxLignesCommande(lignes) {
  let dateDebut = null;
  let dateFin = null;
  lignes.forEach((ligne) => {
    if (ligne.ligneReseau && ligne.ligneReseau.anneeSemaine) {
      const dateAnneeSemaineDebut = getDateWithAnneeSemaineAndJourDepart(
        ligne.ligneReseau.anneeSemaine,
        ligne.ligneReseau.jourDepart,
      );
      const dateAnneeSemaineFin = moment(dateAnneeSemaineDebut).add(7, 'd');
      if (dateAnneeSemaineDebut
        && (moment(dateAnneeSemaineDebut).isBefore(moment(dateDebut)) || !dateDebut)) {
        dateDebut = dateAnneeSemaineDebut;
      }
      if (dateAnneeSemaineFin
        && (moment(dateAnneeSemaineFin).isAfter(moment(dateFin)) || !dateFin)) {
        dateFin = dateAnneeSemaineFin;
      }
    } else {
      if (ligne.dateDebut && (moment(ligne.dateDebut).isBefore(moment(dateDebut)) || !dateDebut)) {
        dateDebut = ligne.dateDebut;
      }
      if (ligne.dateFin && (moment(ligne.dateFin).isAfter(moment(dateFin)) || !dateFin)) {
        dateFin = ligne.dateFin;
      }
    }
  });
  return {
    dateDebut: dateDebut ? new Date(cloneDeep(dateDebut)) : null,
    dateFin: dateFin ? new Date(cloneDeep(dateFin)) : null,
  };
}
